<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="button-group">
    <button mat-raised-button color="primary" (click)="onCreateCurrency()">
      <mat-icon>add</mat-icon>
      Add Currency
    </button>
  </div>
  <app-lookup-table
      [items]="currencies()"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditCurrency($event)"
      (deleteClick)="onDeleteCurrency($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
